module.exports = __webpack_public_path__ + "static/media/logo4.6665178d.png";